const ROUTES = {
  HOME: "/",
  MEET_OUR_VENDORS: "/meet-our-vendors",
  BECOME_A_VENDOR: "/become-a-vendor",
  BECOME_A_BUSKER: "/become-a-busker",
  COMMUNITY_TABLE: "/community-table",
  MARKET_MAP: "/market-map",
  SEE_EVENTS: "/see-our-events",
  RENTAL_SPACES: "/rental-spaces",
  OUR_STORY: "/our-story",
  CONTACT_US: "/contact-us",
  FAQ: "/faqs",
  PLAN_VISIT: "/plan-your-visit",
  MainMarketHall: "/rental-spaces/main-market-hall",
  WorkshopRoom: "/rental-spaces/workshop-room",
  Kitchen: "/rental-spaces/commercial-kitchen",
  RENTAL_QUESTIONNAIRE: "/rental-questionnaire",
  RENTAL_ADMIN: "/rental-questionnaire/admin",
};

export default ROUTES;
